import { useState, useEffect } from "react";
import productdata from "../store/product.json";
import { useNavigate } from "react-router-dom";

// 🔥 Import all images
const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => {
    const key = item.replace("./", "").toLowerCase();
    images[key] = r(item);
  });
  return images;
};

// ✅ All folders
const productImages = importAll(require.context("../../assets/product", false, /\.(png)$/));
const product1Images = importAll(require.context("../../assets/product1", false, /\.(png)$/));
const product1Images1 = importAll(require.context("../../assets/product2", false, /\.(png)$/));
const product1Images2 = importAll(require.context("../../assets/product3", false, /\.(png)$/));
const product1Images3 = importAll(require.context("../../assets/product4", false, /\.(png)$/));
const product1Images4 = importAll(require.context("../../assets/product5", false, /\.(png)$/));
const product1Images5 = importAll(require.context("../../assets/product6", false, /\.(png)$/));
const product1Images6 = importAll(require.context("../../assets/product7", false, /\.(png)$/));
const product1Images7 = importAll(require.context("../../assets/product8", false, /\.(png)$/));
const product1Images8 = importAll(require.context("../../assets/product9", false, /\.(png)$/));
const product1Images9 = importAll(require.context("../../assets/product10", false, /\.(png)$/));
const product1Images10 = importAll(require.context("../../assets/product11", false, /\.(png)$/));
const product1Images11 = importAll(require.context("../../assets/product12", false, /\.(png)$/));
const product1Images12 = importAll(require.context("../../assets/product13", false, /\.(png)$/));
const product1Images13 = importAll(require.context("../../assets/product14", false, /\.(png)$/));
const product1Images14 = importAll(require.context("../../assets/product15", false, /\.(png)$/));
const product1Images15 = importAll(require.context("../../assets/product16", false, /\.(png)$/));
const product1Images16 = importAll(require.context("../../assets/product17", false, /\.(png)$/));
const product1Images17 = importAll(require.context("../../assets/product18", false, /\.(png)$/));
const product1Images18 = importAll(require.context("../../assets/product19", false, /\.(png)$/));
const product1Images19 = importAll(require.context("../../assets/product20", false, /\.(png)$/));
const product1Images20 = importAll(require.context("../../assets/product21", false, /\.(png)$/));

// 🔥 Folder mapping
const folderMap = {
  product: productImages,
  product1: product1Images,
  product2: product1Images1,
  product3: product1Images2,
  product4: product1Images3,
  product5: product1Images4,
  product6: product1Images5,
  product7: product1Images6,
  product8: product1Images7,
  product9: product1Images8,
  product10: product1Images9,
  product11: product1Images10,
  product12: product1Images11,
  product13: product1Images12,
  product14: product1Images13,
  product15: product1Images14,
  product16: product1Images15,
  product17: product1Images16,
  product18: product1Images17,
  product19: product1Images18,
  product20: product1Images19,
  product21: product1Images20,
};

const ProductSlider = () => {
  const [products, setProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(4);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const navigate = useNavigate();

  // ✅ Load products
  useEffect(() => {
    setProducts(productdata);
  }, []);

  // ✅ Limit to 12 products
  const visibleProducts = products.slice(0, 12);

  // ✅ Responsive
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) setItemsPerView(1);
      else if (window.innerWidth < 992) setItemsPerView(2);
      else setItemsPerView(4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔥 Auto slider
  useEffect(() => {
    if (visibleProducts.length <= itemsPerView || isDragging) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev >= visibleProducts.length - itemsPerView ? 0 : prev + 1
      );
    }, 2500);

    return () => clearInterval(interval);
  }, [visibleProducts, itemsPerView, isDragging]);

  // 🔥 Mouse Drag
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const diff = e.pageX - startX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : 0));
      } else {
        setCurrentIndex((prev) =>
          prev < visibleProducts.length - itemsPerView ? prev + 1 : prev
        );
      }
      setIsDragging(false);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // 🔥 Touch Swipe
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    const diff = e.touches[0].clientX - startX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : 0));
      } else {
        setCurrentIndex((prev) =>
          prev < visibleProducts.length - itemsPerView ? prev + 1 : prev
        );
      }
      setStartX(0);
    }
  };

  // 🔥 Navigate
  const showProduct = (id) => {
    navigate(`/product/${id}`);
  };

  // 🔥 Image helper
  const getImage = (folder, imgName) => {
    return folderMap[folder]?.[imgName?.toLowerCase()] || "/fallback.png";
  };

  return (
    <div style={{ overflow: "hidden", padding: "20px", background: "#FFDA01" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px", fontWeight:'700' }}>
        HEALTHY & TASTY PRODUCTS
      </h2>

      <div
        style={{ overflow: "hidden", cursor: "grab" }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        <div
          style={{
            display: "flex",
            transition: isDragging ? "none" : "0.6s ease-in-out",
            transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`,
          }}
        >
          {visibleProducts.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              style={{
                minWidth: `${100 / itemsPerView}%`,
                padding: "10px",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "10px",
                  cursor: "pointer",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                }}
                onClick={() => showProduct(item.id)}
              >
                <div
                  style={{
                    width: "100%",
                    height: "220px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f8f8f8",
                    borderRadius: "10px",
                  }}
                >
                  <img
                    src={getImage(item.folder, item.image[0])}
                    alt={item.name}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>

                <h5 style={{ marginTop: "10px", fontSize: "15px" }}>
                  {item.name}
                </h5>

                <div style={{ display: "flex", gap: "8px", fontSize: "14px" }}>
                  <p style={{ textDecoration: "line-through", color: "gray" }}>
                    ₹{item.price}
                  </p>
                  <p style={{ fontWeight: "700" }}>
                    ₹{item.discounted}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;